import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
} from '@mui/material';
import {
  Search,
  Home,
  TrendingUp,
  Security,
  Support,
  Gavel,
} from '@mui/icons-material';

const ServicesSection = () => {
  const services = [
    {
      icon: <Search />,
      title: 'Property Search',
      description: 'Advanced search filters to help you find your perfect property with location, price, and amenity preferences.',
    },
    {
      icon: <Home />,
      title: 'Property Management',
      description: 'Comprehensive property management services including maintenance, tenant screening, and rent collection.',
    },
    {
      icon: <TrendingUp />,
      title: 'Market Analysis',
      description: 'Get detailed market insights and property valuations to make informed investment decisions.',
    },
    {
      icon: <Security />,
      title: 'Secure Transactions',
      description: 'Safe and secure property transactions with escrow services and legal documentation support.',
    },
    {
      icon: <Support />,
      title: '24/7 Support',
      description: 'Round-the-clock customer support to assist you throughout your property buying or selling journey.',
    },
    {
      icon: <Gavel />,
      title: 'Legal Assistance',
      description: 'Professional legal guidance for contracts, negotiations, and all property-related legal matters.',
    },
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: 'white' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" sx={{ mb: 6 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Our Services
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
            Comprehensive real estate services designed to make your property journey smooth and successful
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  p: 3,
                  borderRadius: 3,
                  border: '1px solid #e0e0e0',
                  boxShadow: 'none',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 32px rgba(0,0,0,0.1)',
                    borderColor: '#2196F3',
                  },
                }}
              >
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  <Avatar
                    sx={{
                      width: 64,
                      height: 64,
                      mb: 3,
                      background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                    }}
                  >
                    {React.cloneElement(service.icon, { sx: { fontSize: 32 } })}
                  </Avatar>
                  
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      color: '#333',
                    }}
                  >
                    {service.title}
                  </Typography>
                  
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ServicesSection;
